import React, { useState, useRef, useEffect } from 'react'
import { connect } from 'react-redux'
import './index.scss'
import { closeModal } from '../../../../action/positioned-modal-state'
import { userFetchRequest } from '../../../../action/user-actions'

const Payment = props => {
  //TODO: cleanup after iframe implementation
  const { closeModal, positionedModal, auth, user, subscriptionPlans } = props,
    [messageListenerSet, setMessageListener] = useState(false),
    [frameLoaded, setFrameLoaded] = useState(false),
    { payment } = positionedModal.data,
    { duration } = payment,
    frame = useRef(null),
    messageHandler = (e) => {
      if (frame.current === null) {
        return
      }
      if (e.data == 'frame loaded') {
        const userData = Object.assign({}, user)
        userData['accessToken'] = auth
        userData['subscriptionPlans'] = subscriptionPlans
        frame.current.style.display = ''
        frame.current.contentWindow.postMessage({ type: 'auth', userData }, '*')
        setFrameLoaded(true)
      }
      if (e.data == 'purchase complete') {
        window.location.reload()
      }
      if (e.data == 'cleared') {
        closeModal()
      }
    },
    clearListener = () => {
      window.removeEventListener('message', messageHandler)
    },
    handleEffect = () => {
      if (!messageListenerSet) {
        setMessageListener(true)
        window.addEventListener('message', messageHandler)
      }
      return clearListener.bind(this)
    },
    visibility = frameLoaded ? '' : 'hidden'
  useEffect(handleEffect.bind(this), [])

  return (
    <div className='payment-bg' onClick={e => {
      e.stopPropagation()
    }}>
      <div className='payment-form-container'>
        <iframe
          ref={frame}
          className='payment-frame'
          style={{ visibility }}
          src={`https://www.staging2.basemap.com/choose-subscription/account/addons/?type=${duration}&ref=internal&env=staging`}>
        </iframe>
        {
          frameLoaded ? (
            <div className='default-close payment-close' onClick={() => {
              if (frame.current) {
                frame.current.contentWindow.postMessage({ type: 'clear' }, '*')
              }
            }}></div>) : (
            <div className='payment-overlay-spinner center'></div>
          )
        }
      </div>
    </div>
  )
}

const mapStateToProps = state => ({
  auth: state.auth,
  user: state.user,
  positionedModal: state.positionedModal,
  subscriptionPlans: state.subscriptionPlans
})

const mapDispatchToProps = dispatch => ({
  userFetchRequest: () => dispatch(userFetchRequest()),
  closeModal: () => dispatch(closeModal())
})

export default connect(mapStateToProps, mapDispatchToProps)(Payment)
